export default __webpack_public_path__ + "static/media/dashboard.0a79a58d.svg";